import { createPortal } from 'react-dom';

export default function ModalPortal({ children, container = null }) {
  if (typeof document === 'undefined') return null;
  try {
    const mount = container && container instanceof Element ? container : document.body;
    return createPortal(children, mount);
  } catch (e) {
    return createPortal(children, document.body);
  }
}
